import { HttpStatusCode } from './http-status-code'

export function getStatusMessage(statusCode: number, message?: string): string {
  switch (statusCode) {
    case HttpStatusCode.INTERNET_UNAVAILABLE:
      return 'No pudimos completar la solicitud, verifica tu internet o inténtalo más tarde.'
    case HttpStatusCode.BAD_REQUEST:
      if (message !== '' && message !== undefined) return message
      return 'Solicitud inválida: la petición es inválida o no puede ser atendida.'
    case HttpStatusCode.UNAUTHORIZED:
      return 'No tienes acceso para realizar esta operación'
    case HttpStatusCode.NOT_FOUND:
      return 'El recurso solicitado no pudo ser encontrado.'
    case HttpStatusCode.INTERNAL_SERVER_ERROR:
      return 'Ocurrió un error inesperado en el servidor.'
    case HttpStatusCode.NOT_IMPLEMENTED:
      return 'El servidor no soporta la funcionalidad necesaria para atender la solicitud.'
    case HttpStatusCode.SERVICE_UNAVAILABLE:
      return 'Estamos realizando mejoras en nuestra aplicación. Por favor, inténtalo nuevamente más tarde.'
    default:
      return 'Ocurrió un error inesperado.'
  }
}
